import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getReferralStatuses } from '@arrived/api_v2';
import { ReferralStatus } from '@arrived/models';

import { UseQueryOptions } from '../queries.utils';
import { referralStatusesQueryKey } from './referrals.keys';

export const useGetReferralStatusesQuery = (options?: UseQueryOptions<ReferralStatus[]>) => {
  return useQuery(referralStatusesQueryKey, async () => getReferralStatuses(), {
    ...options,
  });
};
